import store from "@frameworks/web/redux/store";
import { PROCEED_TO_AUTH, PROCEED_TO_AUTH_ERROR_DATA, PROCEED_TO_AUTH_HIDE_ERROR_DATA, PROCEED_TO_AUTH_START_LOADER, PROCEED_TO_AUTH_STOP_LOADER, } from "../interface/IProceedToAuth";
class ProceedToAuthActions {
    constructor() {
        this.dispatch = store.dispatch;
    }
    proceedToAuth(proceedToAuth) {
        this.dispatch({
            type: PROCEED_TO_AUTH,
            payload: { proceedToAuth },
        });
    }
    setError(payload, errorType) {
        this.dispatch({
            type: PROCEED_TO_AUTH_ERROR_DATA,
            payload: { errorData: payload },
        });
    }
    hideError(errorType) {
        this.dispatch({
            type: PROCEED_TO_AUTH_HIDE_ERROR_DATA,
        });
    }
    loader() {
        this.dispatch({
            type: PROCEED_TO_AUTH_START_LOADER,
        });
    }
    stopLoader() {
        this.dispatch({
            type: PROCEED_TO_AUTH_STOP_LOADER,
        });
    }
}
export default ProceedToAuthActions;
